import { useEffect } from 'react';

const ResourceOptimizer = () => {
  useEffect(() => {
    // Preload delle risorse critiche
    const preloadResources = [
      { href: 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&family=Mohave:wght@400;500;600;700&display=swap', as: 'style' },
      // Aggiungi altre risorse critiche se necessarie
    ];

    preloadResources.forEach(resource => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.href = resource.href;
      link.as = resource.as;
      if (resource.as === 'style') {
        link.onload = function() {
          this.rel = 'stylesheet';
        };
      }
      document.head.appendChild(link);
    });

    // Ottimizzazione delle immagini - aggiunge decoding="async" alle immagini esistenti
    const images = document.querySelectorAll('img');
    images.forEach(img => {
      if (!img.hasAttribute('decoding')) {
        img.setAttribute('decoding', 'async');
      }
      if (!img.hasAttribute('loading') && !img.classList.contains('critical-image')) {
        img.setAttribute('loading', 'lazy');
      }
    });

    // Prefetch delle route più comuni durante il tempo di idle
    const prefetchRoutes = [
      '/login',
      '/register',
      '/profile',
      '/tickets'
    ];

    const prefetchTimeout = setTimeout(() => {
      prefetchRoutes.forEach(route => {
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = route;
        document.head.appendChild(link);
      });
    }, 2000); // Aspetta 2 secondi prima di prefetch

    // Cleanup
    return () => {
      clearTimeout(prefetchTimeout);
    };
  }, []);

  // Questo componente non renderizza nulla
  return null;
};

export default ResourceOptimizer;